import React, {Component} from 'react';
import {compose} from "redux";
import {connect} from "react-redux";
import {firestoreConnect} from "react-redux-firebase";
import {setCompanyData} from "../../redux/register/action";
import {COMPANY_DB_PATH} from "../../constants/DB_PATHS";
import {StateSetterValidator} from "../../utils/Validators";
import {CustomInput, CustomInputField} from "../Inputs";

class EmployeRegisterForm extends Component {

    componentDidUpdate(prevProps, prevState, snapshot) {
        const register = this.props.companyRegister
        StateSetterValidator([
                !!register.employeeCompanyName,
                !!register.employeeCompanyNameId,
            ],
            register.formFilled,
            () => {
                this.props.setCompanyData({formFilled: !register.formFilled})
            }
        )

    }

    render() {
        const register = this.props.companyRegister
        //console.log(this.props)
        //console.log(register)
        return (
            <div>
                <h1>Employee</h1>

                <CustomInput type="text" value={register.employeeCompanyName}
                       onChange={(e) => {
                           this.props.setCompanyData({
                               employeeCompanyName: e.target.value,
                           })
                       }}
                             textTransform={'none'}
                />
                {this.props.companies && this.props.companies.length !== 0 ?
                    <ul>
                        {Object.entries(this.props.companies).map((e, i) => {
                            return (
                                <li key={i}>
                                    <span>{e[1].companyName}</span>
                                    <br/>
                                    <span>{e[1].id}</span>
                                    <button onClick={() => {
                                        this.props.setCompanyData({
                                            employeeCompanyNameId: e[1].id,
                                            employeeCompanyName: e[1].companyName,
                                        })

                                    }}>choose
                                    </button>
                                </li>
                            )
                        })}
                    </ul>
                    :
                    <div>
                        no company with this name
                    </div>
                }

            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        companyRegister: state.companyRegister
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setCompanyData: (data) => dispatch(setCompanyData(data, false)),
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    connect((state, props) => ({
        companies: state.firestore.ordered[COMPANY_DB_PATH]
    })),
    firestoreConnect(props => {
            return [{
                collection: COMPANY_DB_PATH,
                where: [
                    ['companyName', '==', props.companyRegister.employeeCompanyName || ''],
                ]
            }]
        }
    ),
)(EmployeRegisterForm);